module.exports = __webpack_public_path__ + "static/img/defaultAvatar.ec9d8c6a.png";